module.exports = __webpack_public_path__ + "img/cryptocurrency-03.0d6e7f80.svg";